<style>
.btn-edit-img-profile {
    position: absolute;
    bottom: 15px;
    right: -6px;
    background: white;
    width: 30px;
    height: 30px;
    padding: 2px;
    border-radius: 50%;
    cursor: pointer;
}
</style>
<template>
<section id="AcountDetails">
    <div v-if="!onload && show_address" class="row">
        <div class="col-lg-3 col-xl-2 text-center">
            <div class="card-img-actions d-inline-block mb-3">
                <avatar :username="user.first_name" :size="120" :src="imgAvatar" :backgroundColor="'rgb(3, 169, 244)'" :color="'#ffffff'"></avatar>
                <a @click="$refs.fileInput.click()" class="btn-edit-img-profile btn-outline-secondary border btn shadow-sm"><i class="icon-camera"></i></a>
                <input type="file" accept="image/*" @change="uploadImage($event)" id="file-input" class="d-none" ref="fileInput" />
                <!-- <div class="card-img-actions-overlay card-img rounded-circle">
                    <label class="custom-file-upload btn btn-outline bg-white text-white border-white border-2 btn-icon rounded-round" style="font-size: .8125rem;">
                       <input type="file" accept="image/*" @change="uploadImage($event)" id="file-input" class="d-none">
                        <i class="icon-upload4"></i>
                    </label>
                </div> -->
            </div>
        </div>
        <div class="col-lg-9 col-xl-10">

            <div class="form-group row">
                <div class="col-md-12 col-lg-6">
                    <div class="form-group" v-bind:class="{'form-group-error': $v.user.first_name.$error}">
                        <label>{{$t('Full Name')}}
                            <span class="validation-invalid-label d-inline" v-if="!$v.user.first_name.required">{{$t('required data')}}!</span>
                            <span class="validation-invalid-label d-inline" v-if="!$v.user.first_name.minLength">
                                {{
                                $t("Name must have at least") + " " + $v.user.first_name.$params.minLength.min + " " + $t("letters.")
                                }}!
                            </span>
                        </label>
                        <input type="text" class="form-control" v-model.trim.lazy="$v.user.first_name.$model" @change='fetchData'>
                    </div>
                </div>
                <!-- <div class="col-md-12 col-lg-3">
                    <div class="form-group">
                        <label>{{$t('Last Name')}} <span class="validation-invalid-label d-inline" v-if="!$v.user.last_name.required">{{$t('required data')}}!</span></label>
                        <input type="text" class="form-control" v-model="user.last_name" @change='fetchData'>
                    </div>
                </div> -->
                <div class="col-md-6 col-lg-3">
                    <label>{{$t('Email')}}</label>
                    <div class="input-group" data-toggle="modal">
                        <input @click="changeEmail" id="email" type="text" class="form-control" :value="user.email" readonly>
                        <span class="input-group-append">
                            <button disabled type="button" class="btn btn-light btn-icon border-left-0" ><i class="fal fa-lock-alt"></i></button>
                        </span>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label>{{$t('Phone')}}</label>
                    <div class="input-group" data-toggle="modal">
                        <input @click="changePhone" id="mobile" type="text" class="form-control" :value="user.mobile" readonly>
                        <span class="input-group-append">
                            <button disabled type="button" class="btn btn-light btn-icon border-left-0" ><i class="fal fa-lock-alt"></i></button>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row" v-if="show_address">

                <div class="col-lg-12">
                    <div class="form-group">
                        <label>{{$t('Address')}}</label>
                        <input type="text" class="form-control" v-model="user.customer.address1" @change='fetchData' :placeholder="$t('Enter address')">
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>{{$t('Sub District')}}</label>
                        <addressinput-subdistrict v-model="sub_district" inputClass="form-control" label="" :placeholder="$t('Enter sub district')" @change='fetchData'/>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>{{$t('District')}}</label>
                        <addressinput-district v-model="district" inputClass="form-control" label="" :placeholder="$t('Enter district')" @change='fetchData'/>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>{{$t('Province')}}</label>
                        <addressinput-province v-model="province" inputClass="form-control" label="" :placeholder="$t('Enter province')" @change='fetchData'/>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="form-group">
                        <label>{{$t('ZIP/Postal Code')}}</label>
                        <addressinput-zipcode v-model="zipcode" inputClass="form-control" label="" :placeholder="$t('Enter zipcode')" @change='fetchData'/>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{$t('Country')}}</label>
                        <Select2 v-model="country_id" :options="countryOptions" :settings="countryOptionsSettings" @change='fetchData' />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <placeholder-content isLoad="true" />
    </div>
   
</section>
</template>

<script>
import Select2 from "v-select2-component";
import GSCheckbox from "@/components/GSCheckbox.vue";
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import CentralApi from '@/services/endpoint/central.service'
import VueThailandAddress from '@/plugins/vue-thailand-address';
import Avatar from 'vue-avatar'
import { required, minLength } from "vuelidate/lib/validators";

export default {
    components: {
        PlaceholderContent,
        Select2,
        GSCheckbox,
        VueThailandAddress,
        Avatar,
    },
    data() {
        return {
            onload: true,
            hasAvatar: false,
            imgAvatar: '',
            countryOptions: [],
            countryOptionsSettings: {
                minimumResultsForSearch: Infinity,
                templateResult : this.templateCustom,
                templateSelection: this.templateCustomSelect,
                placeholder: {
                    id: '',
                    name: this.$t("Select")+'...'
                },
                allowClear: false,
                escapeMarkup: function (m) {
                    return m;
                },
            },
            show_address: false,
            user: {
                first_name: '',
                last_name: '',
                mobile: '',
                email: '',
                customer: {
                    address1: '',
                    address2: '',
                    sub_district: '',
                    district: '',
                    province: '',
                    zipcode: '',
                    country_id: ''
                },
            },
            sub_district: '',
            district: '',
            province: '',
            zipcode: '',
            country_id: '',
            parentRefs: this.$parent.$refs
        }
    },
    mounted() {
        var self = this;
        setTimeout(function(){
            self.show_address = true;
        }, 3000);
        this.getUser();
        this.getCountry();

    },
    methods: {
        changeEmail(){
            if(!this.$cookie.get('centralToken')) {
                this.logOut();
            }
            if(this.parentRefs.ModalChangeEmailComp != undefined){
                this.parentRefs.ModalChangeEmailComp.currentPassword = '';
                this.parentRefs.ModalChangeEmailComp.validPassword = true;
                this.parentRefs.ModalChangeEmailComp.newEmail = '';
                this.parentRefs.ModalChangeEmailComp.validExistEmail = true;
                this.parentRefs.ModalChangeEmailComp.validEmail = true;
                this.parentRefs.ModalChangeEmailComp.validEmptyEmail = true;
            }
            this.$parent.showModalForgotPassword = false;
            $('#ModalChangeEmail').modal('show')
        },
        changePhone(){
            if(!this.$cookie.get('centralToken')) {
                this.logOut();
            }
            if(this.parentRefs.ModalChangePhone != undefined){
                this.$parent.$refs.ModalChangePhone.currentPassword = '';
                this.$parent.$refs.ModalChangePhone.validPassword = true;
                this.$parent.$refs.ModalChangePhone.validExistPhone = true;
                this.$parent.$refs.ModalChangePhone.validEmptyPhone = true;
            }
            this.$parent.newPhone = ''
            this.$parent.showModalForgotPassword = false;
            $('#ModalChangePhone').modal('show')
            
        },
        fetchData() {
            this.$emit('fetchData', this.user)
        },
        templateCustom(e) {
            let option = "";
            if (e.text == "Searching…") {
                option = this.$t("Searching")+"...";
            } else {
                option = this.$t(e.name);
            }
            return option;
        },
        templateCustomSelect(e) {
            var text = this.$t(e.name);
            return text;
        },
        async getCountry() {
            let data =  await CentralApi.Country.getCountry('?status=1')
            this.countryOptions = data.data.data;
        },
        async getUser() {
            let data = await CentralApi.Auth.getUserProfile();
            this.user = data.data.data;
            if (data.data.data.image_url === '') {
                this.imgAvatar = require("@/assets/images/no-image-user.png");
            } else {
                this.imgAvatar = data.data.data.image_url;
            }
            this.sub_district = data.data.data.customer.sub_district;
            this.district = data.data.data.customer.district;
            this.province = data.data.data.customer.province;
            this.zipcode = data.data.data.customer.zipcode;
            this.country_id = data.data.data.customer.country_id;
            this.onload = false;
            this.fetchData();
        },
        uploadImage(event) {
            var self = this;
            const file = event.target.files[0];
            this.imgAvatar = URL.createObjectURL(file);
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                self.user.image_profile = reader.result;
                self.fetchData();
            };
            reader.onerror = function (error) {
                console.log(error, 'error');
            };
            this.fetchData();
        },
        logOut: async function () {
            await CentralApi.Auth.logOut();
            if(this.$cookie.get('tenantToken')) {
                
                this.$cookie.remove('tenantToken', { domain: '.' + process.env.CENTRAL_API_ROOT });
            }
            this.$cookie.remove('centralToken', { domain: '.' + process.env.CENTRAL_API_ROOT });
            window.location.href = process.env.CENTRAL_API_ROOT + '/login'
        },
    },
    validations: {
        user: {
            first_name: {
                required,
                minLength: minLength(4),
            },
            // last_name: {
            //     required,
            // }
        },
        validationGroup: ['user.first_name', 'user.last_name']
    },
    watch : {
        sub_district:function(val) {
           this.user.customer.sub_district = val;
           this.fetchData();
        },
        district:function(val) {
           this.user.customer.district = val;
           this.fetchData();
        },
        province:function(val) {
           this.user.customer.province = val;
           this.fetchData();
        },
        zipcode:function(val) {
           this.user.customer.zipcode = val;
           this.fetchData();
        },
        country_id:function(val) {
           this.user.customer.country_id = val;
           this.fetchData();
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/central/account/profile/AccountDetails.vue